import type { ComponentProps, ReactNode } from 'react';

import { Field, Switch } from '~/components/Form';

import { descriptionRowStyle, labelStyle, rowStyle } from './FormSwitchField.css';

type Props = ComponentProps<typeof Switch.Root> & { children: ReactNode; description?: ReactNode };

export const FormSwitchField = ({ children, description, ...delegated }: Props) => {
  return (
    <Field.Root className={description ? descriptionRowStyle : rowStyle}>
      <Switch.Root {...delegated} />

      <div>
        <Field.Label className={labelStyle}>{children}</Field.Label>
        {description && <Field.Description>{description}</Field.Description>}
      </div>
    </Field.Root>
  );
};
